export default __webpack_public_path__ + "static/onboarding-e92c6efd3aa56960d3e0e9d1edba06de.webp";